import React from "react";
import PropTypes from "prop-types";

import moment from "moment";

const InfoLabel = ({ group, time }) => {
  const date = moment(time, "x");
  const label = group ? group.title : "";
  return (
    <div
      style={{
        position: "absolute",
        right: 100,
        bottom: 50,
        background: "rgba(0, 0, 0, 0.5)",
        color: "white",
        padding: 10,
        fontSize: 20,
        borderRadius: 5,
        zIndex: 85
      }}
    >
      {`${date.format("LLL")}, ${label}`}
    </div>
  );
};
InfoLabel.propTypes = {
  group: PropTypes.string,
  time: PropTypes.instanceOf(moment)
};
export default InfoLabel;
